import fetch from '../../lib/wrappedFetch'
import config from '../../config'

class RolesService {
  fetchRoles = () => {
    return fetch(config.config.endpointUrls.fetchRoles(), {
      method: 'GET'
    })
  }
}

export default new RolesService()



// WEBPACK FOOTER //
// ../src/services/rolesService/rolesService.js